<template>
    <div>
        <nav class="sm:hidden mb-8">
            <ui-select v-model="activeTab" :options="filteredTabs"></ui-select>
        </nav>
        <nav class="hidden sm:flex items-center" :class="navClass">
            <div v-for="tab in filteredTabs" :key="tab.value">
                <button
                    class="px-3 py-2 font-medium text-sm rounded-md"
                    :class="isActive(tab.value) ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:text-gray-700'"
                    v-text="tab.label"
                    @click="select(tab.value)"
                ></button>
            </div>
        </nav>

        <slot :active-tab="activeTab" :is-active="isActive" :select="select"></slot>
    </div>
</template>

<script>
import {unwrapFunction} from '@utils'

export default {
    props: {
        active: String,
        tabs: Array,
        navClass: {type: String, default: 'space-x-6 mb-8'}
    },
    data() {
        return {
            activeTab: this.active,
        }
    },
    computed: {
        filteredTabs() {
            return this.tabs.filter(tab => tab.when === undefined || unwrapFunction(tab.when))
        },
    },
    methods: {
        isActive(tabValue) {
            return tabValue === this.activeTab
        },
        select(tabValue) {
            this.activeTab = tabValue
            this.$emit('update:activeTab', tabValue)
        },
        reset() {
            this.activeTab = this.active
        },
    },
    watch: {
        tabs: 'reset',
    },
}
</script>
